import React from 'react';
import { Modal, Button, Form, Row, Col, Spinner } from 'react-bootstrap';
import CopyToClipboard from "react-copy-to-clipboard";
import { Link } from "react-router-dom";
import config from '../../config/config';

const NftDetailsModal = ({ show, handleClose, userdata, userdataid, getExpireDay, isMintFunc, cmsData,termsandconditionlist, copieBtn }) => {

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                className="walker_detail"
                centered
                size="xl"
            >
                <Modal.Header closeButton>
                    {/* <Modal.Title>WALKER DETAIL</Modal.Title> */}
                </Modal.Header>
                <Modal.Body className="cust-model">
                    <div>
                        <div>
                            <img src="assets/images/logo-shape2.png" className="top-right" />
                            <img src="assets/images/logo-shape.png" className="botton-left" />
                        </div>
                        <Row className="gy-2 mt-3 sofia-sans">
                            {userdata
                                .filter((item) => item.uniqueId == userdataid)
                                .map((item, index) => (
                                    <>
                                        <Col lg={6}>
                                            <div className="card nftplan h-auto" style={{ borderRadius: 10 }}>
                                                <div className="card-body p-0 h-100">
                                                    <div className=" p-3 px-sm-3 px-3  pb-1">
                                                        <div>
                                                            <div className="d-flex  justify-content-between align-items-center flex-wrap gap-2 mb-2 mt-2">
                                                                <div className="">
                                                                    <h5 className="mb-0 text-white sofia-sans">
                                                                        {item.name}
                                                                    </h5>
                                                                </div>
                                                                {!item.free_signup && (
                                                                    <div>
                                                                        <div

                                                                            className=" sub-btn mh-auto pt-2 pb-2 px-4 responsive-fs-16"
                                                                            style={{ borderRadius: "0px 25px 0px 25px" }}
                                                                        >
                                                                            Subscribed
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="d-flex justify-content-between  pt-2">
                                                                {!item.free_signup && <div className="pla "><p
                                                                    className="text-nowrap px-2 py-1 responsive-fs-16 sofia-sans"
                                                                    style={{ maxWidth: "220px" }}
                                                                >
                                                                    {item.priceMNT} MNT
                                                                </p></div>}
                                                                <div className="pla "><p
                                                                    className="text-nowrap px-sm-3 px-1 py-1 responsive-fs-16 sofia-sans"
                                                                    style={{ maxWidth: "220px" }}
                                                                >
                                                                    {
                                                                        item.is_alpha ? getExpireDay(item.startdate) > 0 ? ` Activate in ${getExpireDay(item.startdate)} days` : `${getExpireDay(item.expiryDate)} days left` : getExpireDay(item.expiryDate) > 0 ? `${getExpireDay(item.expiryDate)} days left` : 'Package Expired'

                                                                    }
                                                                </p></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-view text-center p-2 mb-sm-4 mb-3 mx-sm-4 mx-3  h-100 position-relative" style={{ borderRadius: "20px 5px 20px 20px" }}>
                                                        <div className="position-absolute " style={{ top: 0, right: 0 }}>
                                                            {!item.free_signup && (
                                                                <div

                                                                    className="rounded-1 py-2 px-3 mb-0" style={{ height: "auto", fontSize: 14, color: "#ffffff" }}
                                                                >
                                                                    NFT Id : &nbsp;{item.uniqueId}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <img 
                                                            src={`${config.ipfsurl + item.image}`} className=" img-fluid" style={{height:200}}
                                                            alt={item.image}
                                                        />
                                                    </div>
                                                </div>
                                            </div>


                                        </Col>
                                        <Col lg={6}>
                                            <div className="package_detail">
                                                <ul className="w-100">
                                                    {item.free_signup ? <></> :

                                                        <li className="w-100">
                                                            <Row className="d-flex justify-content-between gy-2">
                                                                <Col lg={7} sm={6} xs={12} className="d-flex align-items-center justify-content-center justify-content-sm-start">
                                                                    <div className=" text-center text-sm-start mb-0 ">
                                                                        Type of NFT
                                                                    </div>
                                                                </Col>
                                                                <Col lg={5} sm={6} xs={12}>
                                                                    <p className="mb-0">
                                                                        {item.editionTypeId == 1
                                                                            ? "Basic Nft"
                                                                            : item.editionTypeId == 2
                                                                                ? "Limited Edition"
                                                                                : "Alpha Edition"}
                                                                    </p>
                                                                </Col>
                                                            </Row>
                                                        </li>
                                                    }
                                                </ul>
                                                <ul className="">

                                                    <li>
                                                        <Row className="d-flex justify-content-between gy-2">
                                                            <Col lg={7} sm={6} xs={12} className="d-flex align-items-center justify-content-center justify-content-sm-start">
                                                                <div className=" text-center text-sm-start mb-0 ">
                                                                    Subscription Expire{" "}
                                                                </div>
                                                            </Col>
                                                            <Col lg={5} sm={6} xs={12}>
                                                                <p className="mb-0">{item.expiryDate} </p>
                                                            </Col>
                                                        </Row>

                                                    </li>
                                                    <li >

                                                        <Row className="d-flex justify-content-between gy-2">
                                                            <Col lg={7} sm={6} xs={12} className="d-flex align-items-center justify-content-center justify-content-sm-start">
                                                                <div className=" text-center text-sm-start mb-0 ">

                                                                    Max Steps
                                                                </div>
                                                            </Col>
                                                            <Col lg={5} sm={6} xs={12}>
                                                                <p className="mb-0">{parseInt(item.capacity)} </p>
                                                            </Col>
                                                        </Row>
                                                    </li>
                                                    <li className="">

                                                        <Row className="d-flex justify-content-between gy-2">
                                                            <Col lg={7} sm={6} xs={12} className="d-flex align-items-center justify-content-center justify-content-sm-start">
                                                                <div className=" text-center text-sm-start mb-0 ">
                                                                    Per Day Reward
                                                                </div>
                                                            </Col>
                                                            <Col lg={5} sm={6} xs={12}>
                                                                {item.free_signup ? (
                                                                    <p className="mb-0">{item.rewardPercent} MNT</p>
                                                                ) : (
                                                                    <p className="mb-0">
                                                                        upto {item.rewardPercent}%
                                                                    </p>
                                                                )}
                                                            </Col>
                                                        </Row>


                                                    </li>

                                                    {item.free_signup && (
                                                        <li className="">

                                                            <Row className="d-flex justify-content-between gy-2">
                                                                <Col lg={7} sm={6} xs={12} className="d-flex align-items-center justify-content-center justify-content-sm-start">
                                                                    <div className=" text-center text-sm-start mb-0 ">
                                                                        Loyalty Bonus
                                                                    </div>
                                                                </Col>
                                                                <Col lg={5} sm={6} xs={12}>
                                                                    {item.loyalty_bonus_percent}
                                                                </Col>
                                                            </Row>


                                                        </li>
                                                    )}

                                                    <div >
                                                        {!item.free_signup && (
                                                            <li>

                                                                <Row className="d-flex justify-content-between gy-2">
                                                                    <Col lg={7} sm={6} xs={12} className="d-flex align-items-center justify-content-center justify-content-sm-start">
                                                                        <div className=" text-center text-sm-start mb-0  ">
                                                                            {item.isminted == 0
                                                                                ? "Minting Status"
                                                                                : "Blockchain View"}
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={5} sm={6} xs={12} className="justify-content-sm-end justify-content-center d-flex">
                                                                        {item.isminted == 0 ? (
                                                                            <Button
                                                                                variant="main2"
                                                                                onClick={() => isMintFunc(item.uniqueId)}
                                                                                className="rounded-1 btn-sm mh-auto pt-2 pb-2   py-1 px-4"
                                                                                style={{ height: 37 }}
                                                                            >
                                                                                Proceed to Mint
                                                                            </Button>
                                                                        ) : (
                                                                            <div className="d-flex w-100">
                                                                                <p className="mb-0 d-flex align-items-center justify-content-center w-100" >
                                                                                   {
                                                                                    item.trxHash ?  
                                                                                    <>
                                                                                    <a
                                                                                        className="mb-0 d-flex align-items-center"
                                                                                        target="_blank"
                                                                                        href={`${item.trxHash}`}
                                                                                        style={{ textDecoration: "none", height: 28 }}
                                                                                    >
                                                                                        {item.trxHash?.slice(23, 4) +
                                                                                            "...." +
                                                                                            item.trxHash?.slice(-4)}

                                                                                    </a>
                                                                                     &emsp;&nbsp;
                                                                                    <CopyToClipboard text={item.trxHash}>
                                                                                        <div>
                                                                                            <i
                                                                                                className="fa fa-clone"
                                                                                                title="Click to Copy"
                                                                                                style={{
                                                                                                    cursor: "pointer",
                                                                                                    color: "#FFF",
                                                                                                }}
                                                                                                onClick={copieBtn}
                                                                                            ></i>
                                                                                        </div>
                                                                                    </CopyToClipboard>
                                                                                    </> : "undefined"
                                                                                   }
                                                                                   
                                                                                </p>
                                                                            </div>
                                                                        )}
                                                                    </Col>
                                                                </Row>
                                                                <div className="d-flex justify-content-between">
                                                                    <div className="d-flex align-items-center">

                                                                    </div>

                                                                </div>
                                                            </li>
                                                        )}
                                                    </div>

                                                </ul>
                                            </div>
                                        </Col>
                                        <div className="package_detail">
                                            <ul className="mb-0">
                                                <div className="row">
                                                    <div className="col-lg-6 " >

                                                        {item.free_signup == true &&

                                                            <div className=" d-flex mb-3 mt-2 pl-0 gap-2 align-items-baseline text-secondary" style={{ zIndex: 999 }}  >
                                                                <div style={{ zIndex: 999 }}>
                                                                    <input className="form-check-input mt-1" style={{ width: 15, height: 15 }} type="checkbox"
                                                                        checked={item.tncchecked}
                                                                        name="checkbox" id="flexCheckDefault" readOnly />
                                                                </div>
                                                                <p style={{ marginTop: "1px", zIndex: 999 }} className="mb-0 sofia-sans">I acknowledge that I have read and agreed to the <Link target="blank" className="text-primary sofia-sans"
                                                                    to={`${config.baseUrl}plantermsandconditions`}>Terms and conditions</Link></p>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className="col-lg-6 ">
                                                        {!item.free_signup && (
                                                            <div >
                                                                <li>
                                                                    <Row className="d-flex justify-content-between">
                                                                        <Col className="d-flex align-items-center">
                                                                            Claim NFT
                                                                        </Col>
                                                                        <Col className="text-end">
                                                                            <Button
                                                                                variant="main2" p
                                                                                className="rounded-1 btn-sm mh-auto pt-2 pb-2 px-4 text-nowrap"
                                                                                disabled
                                                                            >
                                                                                Coming Soon
                                                                            </Button>
                                                                        </Col>

                                                                    </Row>

                                                                </li>
                                                                {item.free_signup == true &&

                                                                    <div className=" d-flex mb-3 mt-2 pl-0 gap-2 align-items-baseline text-secondary" style={{ zIndex: 999 }}  >
                                                                        <div style={{ zIndex: 999 }}>
                                                                            <input className="form-check-input mt-1" style={{ width: 15, height: 15 }} type="checkbox"
                                                                                checked={item.tncchecked}
                                                                                name="checkbox" id="flexCheckDefault" readOnly />
                                                                        </div>
                                                                        <p style={{ marginTop: "1px", zIndex: 999 }} className="mb-0">I acknowledge that I have read and agreed to the <Link target="blank" className="text-primary"
                                                                            to={`${config.baseUrl}plantermsandconditions`}>Terms and conditions</Link></p>
                                                                    </div>
                                                                }
                                                            </div>


                                                        )}
                                                    </div>
                                                </div>

                                            </ul>

                                        </div>

                                        <Col lg={12} className="pt-3">
                                            <p>{item.message}</p>

                                        </Col>
                                        {(!item.free_signup && item.tncchecked && !item.is_alpha) ?
                                            <div className=" d-flex mb-3 mt-2 ms-2  pl-0 gap-2 align-items-baseline text-secondary" style={{ zIndex: 999 }}  >
                                                <div style={{ zIndex: 999 }}>
                                                    <input className="form-check-input mt-1" style={{ width: 15, height: 15 }} type="checkbox"
                                                        checked={item.tncchecked}
                                                        name="checkbox" id="flexCheckDefault" readOnly />
                                                </div>
                                                <p style={{ marginTop: "1px", zIndex: 999 }} className="mb-0">I acknowledge that I have read and agreed to the <Link target="blank" className="text-primary"
                                                    to={`${config.baseUrl}plantermsandconditions`}>Terms and conditions</Link></p>
                                            </div> : ""
                                        }
                                        {(!item.free_signup && item.tncchecked && item.is_alpha) ?
                                            <div className=" d-flex mb-3 mt-2 ms-2  pl-0 gap-2 align-items-baseline text-secondary" style={{ zIndex: 999 }}  >
                                                <div style={{ zIndex: 999 }}>
                                                    <input className="form-check-input mt-1" style={{ width: 15, height: 15 }} type="checkbox"
                                                        checked={item.tncchecked}
                                                        name="checkbox" id="flexCheckDefault" readOnly />
                                                </div>
                                                <p style={{ marginTop: "1px", zIndex: 999 }} className="mb-0">I acknowledge that I have read and agreed to the <Link target="blank" className="text-primary"
                                                    to={`${config.baseUrl}alphaplantermsandconditions`}>Terms and conditions</Link> of Alpha Package.</p>
                                            </div> : ""
                                        }
                                        {item.free_signup &&
                                            <div>
                                                <p className="mb-2  ms-3 text-light">Review Terms : </p>
                                                <ul
                                                    dangerouslySetInnerHTML={{ __html: termsandconditionlist.freeSignUpterms }}

                                                />

                                            </div>
                                        }
                                    </>
                                ))}
                        </Row>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    );
};

export default NftDetailsModal;
